import { z } from "zod";

export const priceScheme = z.object({
  newPrice: z.string().min(1, 'Обов\'язкове поле'),
  changeReason: z.string().min(1, 'Обов\'язкове поле'),
});

export type PriceFormScheme = z.infer<typeof priceScheme>;

export const loyaltyScheme = z.object({
  loyalty: z.string().min(1)
});

export type LoyaltyFormScheme = z.infer<typeof loyaltyScheme>;
